'use client';
import { Button } from '@/components/button/button';
import Modal from '@/components/modal/modal';
import { Heading } from '@/components/typography/heading';

import styles from './YAMLViewerModal.module.scss';

type YAMLViewerModalProps = {
  yamlContent: string;
  contractName: string;
  onClose: () => void;
};

export default function YAMLViewerModal( { yamlContent, contractName, onClose }: YAMLViewerModalProps ) {
  return (
    <Modal
      className={ styles.yamlModal }
      resizable={ true }
      modalType="yaml-viewer"
      initialSize="large"
    >
      <div className={ styles.modalInner }>
        <div className={ styles.header }>
          <Heading as="h2" size="md">Data Contract YAML</Heading>
          <p className={ styles.contractName }>{contractName}</p>
        </div>
        <div className={ styles.content }>
          <pre className={ styles.yamlContent }>
            <code>{yamlContent}</code>
          </pre>
        </div>
        <div className={ styles.footer }>
          <Button variant="secondary" size="sm" onClick={ onClose }>
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
}
